import { createFileRoute } from "@tanstack/react-router";
import i18n from "@/i18n";
import { pageHead, technologyJsonLdScript } from "@/lib/seo";
import { TechnologiePage } from "@/pages/technologie";

export const Route = createFileRoute("/$lang/technologie")({
  head: ({ params }) => {
    const lang = (params.lang as "fr" | "en") ?? "fr";
    const t = i18n.getFixedT(lang, "seo");
    const head = pageHead({
      lang,
      pathWithoutLang: "/technologie",
      title: t("technologie.title"),
      description: t("technologie.description"),
    });
    return { ...head, scripts: [technologyJsonLdScript(lang)] };
  },
  component: TechnologiePage,
});
